<template>
  <div id="zhzy">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'zhzy'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/news/style/Style.vue